import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuftragsKomponente } from 'src/app/api/model/swagger-model';
import { Auftragdetails } from '../auftragdetails.helper';
import { KomponenteBase } from './komponente';

@Component({
    selector: 'auftrag-barcode-komponente',
    template: `
        <div class="section" style="padding-bottom: 0;">
          <div class="barcode-container">
            <div *ngIf="!auftrag.barcodeAusgeblendet" class="barcode ion-activatable" appClick (clicked)="anzeigenBarcode()">
              <app-auftrag-barcode [auftrag]="auftrag"></app-auftrag-barcode>
            </div>

            <ion-button fill="clear" class="button48" *ngIf="!auftrag.barcodeAusgeblendet" appClick (clicked)="onBarcodeAusblenden()">
              <ion-icon slot="icon-only" name="eye-off"></ion-icon>
            </ion-button>

            <div *ngIf="auftrag.barcodeAusgeblendet" class="barcode-label">Barcode</div>

            <ion-button fill="clear" class="button48 btn-einblenden" *ngIf="auftrag.barcodeAusgeblendet" appClick (clicked)="onBarcodeEinblenden()">
              <ion-icon slot="icon-only" name="eye"></ion-icon>
            </ion-button>
          </div>
        </div>
    `,
    styles: [`
    .barcode-container {
        position: relative;
        min-height: 48px;
    }

    .barcode {
        padding-right: 50px;
    }

    .barcode-label {
        line-height: 48px;
        padding-right: 50px;
    }

    ion-button.button48 {
        position: absolute;
        top: 0;
        right: 0;
    }

    ion-button.btn-einblenden {
        opacity: 0.3;
    }
    `],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class AuftragBarcodeComponent extends KomponenteBase implements OnInit {

    @Input() auftragdetails: Auftragdetails;
    @Input() komponente: AuftragsKomponente;

    constructor(
        private router: Router,
        protected cdr: ChangeDetectorRef) {
        super(cdr);

        // alert('auftrag-barcode-komponente constructor');
    }

    ngOnInit() {
        super.ngOnInit();
    }

    async anzeigenBarcode() {
        await this.auftragdetails.anzeigenBarcode();
    }

    onBarcodeAusblenden() {
        this.auftrag.barcodeAusgeblendet = true;
    }

    onBarcodeEinblenden() {
        this.auftrag.barcodeAusgeblendet = false;
    }

    // ngOnDestroy(): void {
    //     super.ngOnDestroy();

    //     alert('auftrag-barcode-komponente ngOnDestroy');
    // }

}
